import { isNative } from "@/lib/capacitor";
import { recreateAllChannels } from "@/lib/realtimeChannels";

/**
 * On iOS, when the WebView is backgrounded and resumed the underlying
 * WebSocket can appear open while every realtime channel is dead. To keep
 * feed/messages/notifications live after foregrounding, we listen for
 * `appStateChange` (Capacitor App plugin) and tear down + replay every
 * registered channel via `recreateAllChannels`.
 *
 * No-op on web. Idempotent: each registered listener is keyed by Capacitor
 * to the App plugin instance, so calling once at boot is correct.
 */
export async function initializeRealtimeReconnect(): Promise<void> {
  if (!isNative) return;
  const { App } = await import("@capacitor/app");
  await App.addListener("appStateChange", ({ isActive }) => {
    if (isActive) void recreateAllChannels();
  });
}
